<template>
  <validation-provider
    ref="fileInput"
    v-slot="{ errors }"
    rules="file_size"
    :vid="vid"
    :name="name">
    <file-uploader
      :value="_value"
      @input="onInputFile" />
    <BaseErrorMessage :errors="[...errors, ...responseFieldErrors]" />
  </validation-provider>
</template>

<script>
import FileUploader from '@/components/parts/FileUploader.vue'
import BaseErrorMessage from '@/components/parts/BaseErrorMessage.vue'
export default {
  components: {
    FileUploader,
    BaseErrorMessage
  },
  props: {
    value: {
      type: [String, File],
      default: null
    },
    name: {
      type: String,
      default: undefined
    },
    responseErrors: {
      type: Object,
      default: null
    },
    vid: {
      type: String,
      default: null
    },
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    responseFieldErrors() {
      return this.responseErrors?.[this.vid] || null
    }
  },
  methods: {
    onInputFile(file) {
      this._value = file

      if (file == null) {
        this.$refs.fileInput.reset()
      }
    }
  }
}
</script>

<style>

</style>